import React, { useState } from 'react';
import Modal from '../common/Modal';
import { useToast } from '../../context/ToastContext';
import { supabase } from '../../lib/supabase';
import { useNavigate } from 'react-router-dom';

export default function CreateTableModal({ isOpen, onClose, projectId, onTableCreated }) {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const initialColumns = [
        { id: 'col-a', name: 'Column A' },
        { id: 'col-b', name: 'Column B' },
        { id: 'col-c', name: 'Column C' }
      ];

      const { data, error } = await supabase
        .from('data_tables')
        .insert([{
          name: name.trim(),
          project_id: projectId,
          column_order: initialColumns,
          dataset: [{
            'Column A': '',
            'Column B': '',
            'Column C': ''
          }]
        }])
        .select()
        .single();

      if (error) throw error;

      const parsedData = {
        ...data,
        column_order: initialColumns
      };

      addToast('Table created successfully', 'success');
      onTableCreated?.(parsedData);
      onClose();
      setName('');
      
      navigate(`/content/tables/${parsedData.id}`);
    } catch (error) {
      console.error('Error creating table:', error);
      addToast('Failed to create table', 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <h3 className="text-lg font-medium">Create New Table</h3>
          <p className="mt-1 text-sm text-gray-400">
            Create a new table with default columns. You can add or modify columns after creation.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Table Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 bg-dark-300 border border-divider rounded focus:outline-none focus:border-accent-primary"
            placeholder="Enter table name"
            required
          />
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-400 hover:text-white transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={saving || !name.trim()}
            className="px-4 py-2 bg-accent-primary text-white rounded hover:bg-accent-primary/90 disabled:opacity-50 transition-colors"
          >
            {saving ? 'Creating...' : 'Create Table'}
          </button>
        </div>
      </form>
    </Modal>
  );
} 